__turbopack_context__.v({
  "arrow": "JournalFeatured-module-scss-module__gwTsoG__arrow",
  "blink": "JournalFeatured-module-scss-module__gwTsoG__blink",
  "categories": "JournalFeatured-module-scss-module__gwTsoG__categories",
  "category": "JournalFeatured-module-scss-module__gwTsoG__category",
  "content": "JournalFeatured-module-scss-module__gwTsoG__content",
  "hidden": "JournalFeatured-module-scss-module__gwTsoG__hidden",
  "image": "JournalFeatured-module-scss-module__gwTsoG__image",
  "imageContainer": "JournalFeatured-module-scss-module__gwTsoG__imageContainer",
  "imageFull": "JournalFeatured-module-scss-module__gwTsoG__imageFull",
  "imageHover": "JournalFeatured-module-scss-module__gwTsoG__imageHover",
  "journalFeatured": "JournalFeatured-module-scss-module__gwTsoG__journalFeatured",
});
